export default __webpack_public_path__ + "static/media/link.c8267256.png";